import React, { FC } from 'react';
import { Paragraph, Heading3 } from '@hox/ui/Typography';
import { RouteComponentProps } from 'react-router';
import styled from 'styled-components';
import { LinkButton } from '@hox/ui/Button';
import { FormattedMessage } from 'react-intl';
import { getErrorMessage } from './errors';

interface IQueryParamErrorProps extends RouteComponentProps {}

const QueryParamErrorStyled = styled.div`
  text-align: center;

  > * {
    margin-bottom: 1.5rem;
    :last-child {
      margin-bottom: 0;
    }
  }
`;

const getLoginParams = (errorParams: string) => {
  const params = new URLSearchParams(errorParams);
  params.delete('error');
  params.delete('error_description');
  return params.toString();
};

const QueryParamError: FC<IQueryParamErrorProps> = ({ location }) => {
  const params = new URLSearchParams(location.search);

  const error = params.get('error');
  const errorDescription = params.get('error_description');
  return (
    <QueryParamErrorStyled>
      <Heading3>
        <FormattedMessage
          id="auth.error.errorTitle"
          defaultMessage="Something went wrong"
          description="Title on an error page that gives information about what when wrong with the signin."
        />
      </Heading3>
      <Paragraph>{getErrorMessage(error, errorDescription)}</Paragraph>
      <Paragraph>
        <FormattedMessage
          id="auth.error.contactMessage"
          defaultMessage="If the problem persists contact your system administrator or {supportEmail}"
          description="Contact support message in case error persists"
          values={{
            supportEmail: 'support@hoxhunt.com',
          }}
        />
      </Paragraph>
      <LinkButton
        color="primary"
        to={{ pathname: '/', search: getLoginParams(location.search) }}
      >
        <FormattedMessage
          id="auth.general.backToLoginButton"
          defaultMessage="Back to login"
          description="Back to login button text"
        />
      </LinkButton>
    </QueryParamErrorStyled>
  );
};

export { QueryParamError };
